module.exports = __webpack_public_path__ + "resources/img/img_experdb2.86fc5c132c0d474c813b784b4d3f155a.png";